import React from "react";
import Skill from "./Skill";

const skills = [
  {
    index: "A",
    header: "Algorithms & Signal Processing",
    body: "Navigation and detection algorithms for real-world systems — GNSS and navigation work for the Ground Forces, a >90% detection-accuracy improvement under interference, and FMCW Lidar validation pipelines at Mobileye.",
    tags: [
      "MATLAB",
      "Python",
      "GNSS",
      "Navigation Systems",
      "Detection",
      "FMCW Lidar",
    ],
  },
  {
    index: "B",
    header: "Embedded & Electronics",
    body: "Practical electronics engineering: digital and analog circuit design, low-level programming for microcontrollers, and prototyping on Arduino and Raspberry Pi.",
    tags: [
      "C",
      "C++",
      "Arduino",
      "Raspberry Pi",
      "8051 Assembly",
      "VHDL",
    ],
  },
  {
    index: "C",
    header: "Systems & Networking",
    body: "Comfortable with everything beneath the algorithm — Linux environments, Docker containers, and the protocols that move data between machines and sensors.",
    tags: ["Linux", "Docker", "RS232", "TCP", "UDP", "SSL", "SSH"],
  },
];

const Skills = () => (
  <section id="skills" className="section">
    <div className="section-head">
      <span className="section-num">03</span>
      <h2>Skills</h2>
    </div>
    <div className="skills-grid">
      {skills.map((skill) => (
        <Skill key={skill.index} {...skill} />
      ))}
    </div>
  </section>
);

export default Skills;
